import { createContext, FC, PropsWithChildren, useContext } from 'react';
import { OrganisationIdAndNameOnly } from '@/types/organisation';

const OrganisationOverrideContext = createContext<
  OrganisationIdAndNameOnly | undefined
>(undefined);

export const OrganisationOverrideProvider: FC<
  PropsWithChildren<{ organisation: OrganisationIdAndNameOnly }>
> = ({ children, organisation }) => (
  <OrganisationOverrideContext.Provider value={organisation}>
    {children}
  </OrganisationOverrideContext.Provider>
);

export const useOrganisationOverrideContext = ():
  OrganisationIdAndNameOnly | undefined =>
  useContext(OrganisationOverrideContext);
